import { render, staticRenderFns } from "./SpaceTeamsList.vue?vue&type=template&id=389e6ae2&"
import script from "./SpaceTeamsList.vue?vue&type=script&lang=js&"
export * from "./SpaceTeamsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports